import { Component, Input, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { FirestoreService } from "../firestore-service.service"
import { Emoticon } from '../container';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-emoticons',
    templateUrl: './emoticons.component.html',
    styleUrl: './emoticons.component.scss',
    standalone: true,
    imports: [CommonModule, FormsModule],
})
export class EmoticonsComponent {
  @Input() organizationKey = ""
  @Input() projectKey = ""
  @Input() userId = ""
  @Input() contentKey = ""
  @Input() canvasObjectKey = ""
  @Output() isListening = new EventEmitter<boolean>();
  @Output() onUpdateEmoticons = new EventEmitter<{canvasObjectKey: string, emoticons: string}>();
  emoticons: Emoticon[] = []
  emoticonsPallete: { name: string; symbol: string }[] = []
  groupedEmoticons: { symbol: string; count: number, isUserEmoticonAlso: boolean }[] = []
  isEmoticonsPalleteVisible = false

  constructor(private firestore: FirestoreService) {
  }

  ngAfterViewInit() {
   // this.getEmoticons()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['contentKey'] || changes['canvasObjectKey']) {
      if (this.canvasObjectKey != "" && this.canvasObjectKey != null) {
        this.getEmoticons()
      }
    }
  }

  ngOnDestroy() {
    this.emoticons = []
    this.emoticonsPallete = []
    this.groupedEmoticons = []
    this.isEmoticonsPalleteVisible = false
  }

  async getEmoticons() {
    await this.firestore.getEmoticonsByContentKey(this.organizationKey, this.contentKey).then((emoticons) => {
      this.emoticons = emoticons
      if (this.canvasObjectKey != "") {
       this.emoticons = this.emoticons.filter(em => em.canvasObjectKey == this.canvasObjectKey)
      } 
      this.filterEmoticonsPallete()
      this.countEmoticons()
    })
  }

  filterEmoticonsPallete() {
    this.emoticonsPallete = [...this.firestore.emoticonTypes]
    if (this.canvasObjectKey != "") {
      this.emoticonsPallete = this.emoticonsPallete.filter(emoticon => !this.emoticons.some(e => e.userId === this.userId && e.symbol === emoticon.symbol && e.canvasObjectKey == this.canvasObjectKey))
    } else {
      this.emoticonsPallete = this.emoticonsPallete.filter(emoticon => !this.emoticons.some(e => e.userId === this.userId && e.symbol === emoticon.symbol))
    }
  }

  generateEmoticonsString() {
    let emoticonsString = "" // this.emoticons.map(em => em.symbol).join(" ") + em." " + em.symbol
    this.emoticons.sort((a, b) => a.symbol.localeCompare(b.symbol))
    const groupedMap = this.emoticons.reduce((acc, reaction) => {
      const { symbol, userId } = reaction;
    
      // If the symbol is not yet a key in our accumulator, initialize it
      if (!acc[symbol]) {
        acc[symbol] = {
          symbol: symbol,
          count: 0,
          users: []
        };
      }
    
      // Increment the count and add the user
      acc[symbol].count++;
      acc[symbol].users.push(userId);
      return acc;
    }, {} as { [key: string]: GroupedReaction });
    const groupedArray: GroupedReaction[] = Object.values(groupedMap);
      for (const e of groupedArray) {
          emoticonsString += e.symbol + " " + e.count + " "
      }
    return emoticonsString
  }

  async addEmoticon(emoticon: string, symbol: string) {
    this.isListening.emit(false)
    let em: Emoticon = {
      name: emoticon,
      symbol: symbol,
      userId: this.userId,
      dateOfCreation: new Date(),
      commentKey: this.contentKey,
      canvasObjectKey: this.canvasObjectKey,
      key: this.firestore.generateUID()
    }
    this.emoticons.push(em)
    this.countEmoticons()
    this.filterEmoticonsPallete()
    const emoticonsString = this.generateEmoticonsString()
    this.onUpdateEmoticons.emit({canvasObjectKey: this.canvasObjectKey, emoticons: emoticonsString})
    await this.firestore.addEmoticon(this.organizationKey, this.contentKey, this.canvasObjectKey, em, emoticonsString)

    this.isEmoticonsPalleteVisible = false
    setTimeout(() => {
      this.isListening.emit(true)
    }, 1000)
  }

  countEmoticons() {
    const emoticonCountMap: { [key: string]: number } = {};
    for (const emoticon of this.emoticons) {     // Count occurrences of each emoticon symbol
      if (emoticonCountMap[emoticon.symbol]) {
        emoticonCountMap[emoticon.symbol]++;
      } else {
        emoticonCountMap[emoticon.symbol] = 1;
      }
    }
    this.groupedEmoticons = Object.keys(emoticonCountMap).map(symbol => ({
      symbol: symbol,
      count: emoticonCountMap[symbol],
      isUserEmoticonAlso: this.emoticons.some(emoticon => emoticon.symbol === symbol && emoticon.userId === this.userId)
    })).filter(emoticon => emoticon.symbol !== "undefined")
  }


  async deleteEmoticon(emoticonSymbol: string) {
    this.isListening.emit(false)
    const key = this.emoticons.find(em => em.symbol === emoticonSymbol && em.userId === this.userId)?.key
    if (key) {
      let emoticonsString = ""
      this.emoticons = this.emoticons.filter(em => em.key !== key)
      this.countEmoticons()
      this.filterEmoticonsPallete()
      if (this.emoticons.length > 0) {
        emoticonsString = this.generateEmoticonsString()
      }
      await this.firestore.deleteEmoticon(this.organizationKey, this.contentKey, this.canvasObjectKey, key, emoticonsString)
      this.onUpdateEmoticons.emit({canvasObjectKey: this.canvasObjectKey, emoticons: emoticonsString})
    }
    setTimeout(() => {
      this.isListening.emit(true)
    }, 1000)
  }

}

interface GroupedReaction {
  symbol: string;
  count: number;
  // Optional: you could also include other data, like the userIds
  users: string[]; 
}